import React from 'react';
import PropTypes from 'prop-types';

export default class ListingControlsTrigger extends React.PureComponent {

    render() {
        return (
            <div className="listing__controls-trigger">
                <div onClick={this.props.onClick} className="btn btn--grey btn--bordered listing__controls-trigger-btn">
                    {this.props.isControlsOpened ?
                        <svg className="icon" width="18" height="18">
                            <use xlinkHref="#icon-cross"></use>
                        </svg> :
                        <svg width="22" height="18" className="icon">
                            <use xlinkHref="#icon-refine"></use>
                        </svg>
                    }
                </div>
            </div>
        );
    }
}

ListingControlsTrigger.propTypes = {
    onClick: PropTypes.func.isRequired,
    isControlsOpened: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./app/components/listing/js/ListingControlsTrigger.js